import { useEffect, useRef } from 'react';

export const useMobileNavigation = () => {
  const touchStartRef = useRef(null);
  const touchEndRef = useRef(null);

  useEffect(() => {
    const handleTouchStart = (e) => {
      touchStartRef.current = e.touches[0].clientX;
    };

    const handleTouchMove = (e) => {
      touchEndRef.current = e.touches[0].clientX;
    };

    const handleTouchEnd = () => {
      if (!touchStartRef.current || !touchEndRef.current) return;

      const distance = touchStartRef.current - touchEndRef.current;
      const isLeftSwipe = distance > 50; // Minimum swipe distance

      if (isLeftSwipe) {
        // This is a back swipe gesture - let the browser handle it naturally
        console.log('Back swipe detected');
      }

      // Reset touch positions
      touchStartRef.current = null;
      touchEndRef.current = null;
    };

    // Add touch event listeners
    document.addEventListener('touchstart', handleTouchStart, { passive: true });
    document.addEventListener('touchmove', handleTouchMove, { passive: true });
    document.addEventListener('touchend', handleTouchEnd, { passive: true });

    // Cleanup
    return () => {
      document.removeEventListener('touchstart', handleTouchStart);
      document.removeEventListener('touchmove', handleTouchMove);
      document.removeEventListener('touchend', handleTouchEnd);
    };
  }, []);

  // Function to handle back navigation
  const safeBackNavigation = () => {
    try {
      // Check if we're on a gallery page and can navigate to subcategory
      const currentPath = window.location.pathname;
      const galleryMatch = currentPath.match(/\/gallery\/([^\/]+)\/([^\/]+)/);
      
      if (galleryMatch) {
        const [, categoryName] = galleryMatch;
        // Navigate to subcategory page instead of using history.back()
        window.location.href = `/subcategory/${categoryName}`;
      } else {
        // Use window.history.back() for other cases
        window.history.back();
      }
    } catch (error) {
      console.warn('Back navigation error:', error);
      // Fallback to window.location
      window.history.go(-1);
    }
  };

  return { safeBackNavigation };
}; 